import { useEffect, useState } from 'react';
import { Keyboard } from 'react-native';

import { useDialogContext } from '../../common/utils/context';

/*
 * This hook exists because of InputNumber component (src/native/components/input/InputNumber.js)
 * It calls onChange fuction as onBlur. If we change value and click on button,
 * save button function would be run with unchanged input value.
 * Probably we can get rid of this hacky solution by rewriting input components
 * and running its onChange and onBlur callbacks properly.
 */

const useDialogSaveButton = (onSave) => {
	const [isSaveButtonPressed, setIsSaveButtonPressed] = useState(false);

	const onSaveButtonPress = () => {
		setIsSaveButtonPressed(true);
	};

	const { closeDialog } = useDialogContext();

	useEffect(() => {
		if (isSaveButtonPressed) {
			Keyboard.dismiss();

			setTimeout(async () => {
				if (onSave) {
					await onSave();
				}

				closeDialog();
			}, 100); // required to wait for keyboard dismiss https://github.com/wix/react-native-navigation/issues/2318
		}
	}, [isSaveButtonPressed, onSave, closeDialog]);

	return {
		isSaveButtonPressed,
		onSaveButtonPress,
	};
};

export default useDialogSaveButton;
